/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import * as DataHelpers from "../utils/data-helpers";
import { graphql, useStaticQuery } from 'gatsby'
import { windowObject } from "../utils/browser-helpers";
import merge from 'deepmerge';

function SEO({ lang, meta }) {

  const dataImages = useStaticQuery(graphql`
  {
    allFile {
      edges {
        node {
          publicURL
          base
        }
      }
    }
  }
  `)
  

  let updMeta = {...meta};
  if(meta?.og?.image?.toLowerCase().indexOf('http') !== 0)
  {
    const ogImage = dataImages.allFile.edges.find(e => e.node.base === meta.og.image);
    if(ogImage)
    {
      const winObj = windowObject();
      const hostname = winObj ? `${winObj.location.protocol}//${winObj.location.host}` : '';
      updMeta = merge.all([updMeta, { og: { image: `${hostname}${ogImage.node.publicURL}` }}]);
    }
  }

  const helmetMeta = DataHelpers.metaForHelmets(updMeta);
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={meta?.title}
      meta={helmetMeta}
    />
  )
}

SEO.defaultProps = {
  lang: `it`,
}

SEO.propTypes = {
  lang: PropTypes.string,
  meta: PropTypes.object,
}

function metaFromProject(project) {

}

export default SEO
export { metaFromProject }